import { useLocation } from "react-router-dom";
import { useT } from "../../i18n";

/** Placeholder for company area sections not built yet. */
export default function CompanyComingSoon() {
  const t = useT();
  const { pathname } = useLocation();

  return (
    <div className="rounded-card bg-white px-6 py-14 text-center">
      <h1 className="m-0 mb-1.5 text-lg font-medium">{t.company.comingSoon.title}</h1>
      <p className="m-0 text-sm text-muted">
        <code className="font-mono text-[13px]">{pathname}</code>
        {t.company.comingSoon.notBuilt}
      </p>
    </div>
  );
}
